import React, { FC } from 'react';
import { useRouter } from 'next/router';
import styles from './ProductCardPricingDetails.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import { addCommas } from '@persian-tools/persian-tools';
import { discountPercentHandler } from '@/helpers/discountPercentHandler';
import { ProductListPricing } from '../../types';
type ProductCardPricingDetailsProps = {
  pricing: ProductListPricing;
  lateNight?: boolean;
};
const ProductCardPricingDetails: FC<ProductCardPricingDetailsProps> = ({
  pricing,
  lateNight
}) => {
  const router = useRouter();
  const hasCheckinCheckout = router.query.checkin && router.query.checkout || lateNight;
  const isDiscounted = pricing?.total?.amount !== pricing?.total_without_discount?.amount;
  const isPriceAfterDiscountDifferent = pricing?.price_after_discount?.amount !== pricing?.price_without_discount?.amount;
  const priceTypeLabel = hasCheckinCheckout ? 'قیمت کل' : 'از شبی';
  const priceAmount = hasCheckinCheckout ? pricing?.total?.amount : pricing?.price_after_discount?.amount;
  const totalDiscountPercent = hasCheckinCheckout ? discountPercentHandler(pricing?.total_without_discount?.amount, pricing?.total?.amount) : null;
  const priceDiscountPercent = discountPercentHandler(pricing?.price_without_discount?.amount, pricing?.price_after_discount?.amount);
  return <Box className={styles['pricing_description']} data-sentry-element="Box" data-sentry-component="ProductCardPricingDetails" data-sentry-source-file="ProductCardPricingDetails.tsx">
      <Box className={styles['pricing_with_discount']} data-sentry-element="Box" data-sentry-source-file="ProductCardPricingDetails.tsx">
        <Typography variant="bodyM" className={styles['price_text']} data-sentry-element="Typography" data-sentry-source-file="ProductCardPricingDetails.tsx">
          {priceTypeLabel}
        </Typography>
        <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="ProductCardPricingDetails.tsx">{addCommas(priceAmount)}</Typography>
        <Typography variant="bodyM" className={styles.price_text} data-sentry-element="Typography" data-sentry-source-file="ProductCardPricingDetails.tsx">
          تومان
        </Typography>
      </Box>

      {hasCheckinCheckout && isDiscounted && <Box className={styles['pricing_without_discount']}>
          <Typography variant="bodyM" className={styles['pricing_without_discount_text']}>
            {addCommas(pricing?.total_without_discount?.amount)}
          </Typography>
          <Box className={styles['discount_badge']}>{`${totalDiscountPercent}%`}</Box>
        </Box>}

      {!hasCheckinCheckout && isPriceAfterDiscountDifferent && <Box className={styles['pricing_without_discount']}>
          <>
            <Typography variant="bodyM" className={styles['pricing_without_discount_text']}>
              {addCommas(pricing?.price_without_discount?.amount)}
            </Typography>
            <Box className={styles['discount_badge']}>{`${priceDiscountPercent}%`}</Box>
          </>
        </Box>}
    </Box>;
};
export default ProductCardPricingDetails;